import React, { useMemo } from 'react';

// DEPENDENCIES
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL FUNCTIONS
import { checkRole } from 'functions.js';

// GLOBAL HELPERS
import useLookup from 'helpers/useLookup';
import { useFormikContext } from 'formik';

// GLOBAL COMPONENTS
import Card from 'parts/card/Card';
import Form from 'core/form/Form';
import Record from 'parts/record/Record';

// MAIN COMPONENT
const Update = () => (
  <Record.Update
    recordLabel="vendor"
    endpoints={ENDPOINTS.admin.vendor}
    initialValues={{
      is_active: 1,
      is_global: false
    }}
    formatParams={({ make_dealer_id_list, ...v }) => ({
      ...v,
      make_dealer_id_list:
        make_dealer_id_list && !isArray(make_dealer_id_list) //
          ? make_dealer_id_list?.split(',')
          : make_dealer_id_list
    })}
  >
    <Card body={<FormBody />} />
  </Record.Update>
);

const FormBody = () => {
  // HOOKS
  const { lookup: storesByDealerGroup = [] } = useLookup({ lookup: 'storesByDealerGroup' });

  // CONTEXT
  const { values } = useFormikContext() || {};
  const { is_global } = values || {};

  // MEMOS
  const isAdmin = useMemo(() => checkRole(['dslAdmin']), []);

  // TODO: Get rid of need for this
  const isGlobal = ['true', true].includes(is_global);

  return (
    <Form.Body>
      <Form.YesNo name="is_active" label="Active" required />
      <Form.Control name="vendor_name" label="Vendor Name" required />
      <Form.Control name="vendor_contact" label="Vendor Contact Name" required />
      <Form.Control name="vendor_email_address" label="Vendor Email" schema="email" required />
      <Form.Control name="vendor_phone_number" label="Vendor Phone" type="tel" required />
      {isAdmin && <Form.YesNo name="is_global" label="Global" required numeric={false} />}
      {(!isGlobal || !isAdmin) && !isEmpty(values) && (
        <Form.Checklist
          name="make_dealer_id_list"
          label="Store"
          toggleAll
          options={storesByDealerGroup.map(({ make_dealer_id, dealer_name }) => ({
            label: dealer_name,
            value: make_dealer_id
          }))}
          required
          useCSV
          useNone
        />
      )}
      <Record.Log />
    </Form.Body>
  );
};

// EXPORT
export default Update;
